import React from 'react';
import './MyaPopUp.css';
import 'intersection-observer';

const MyaPopUp = () => {
  return (
    <div className="popup-container">
      <div
        className="popup-close"
        onClick={() => window.parent.postMessage('closePopUp', '*')}
      >
        <img
          src={
            'https://images.squarespace-cdn.com/content/v1/5e8cc39390c57e55e266b95b/070afc7a-f8df-419c-8a0d-b1913c088766/myuti-close.png?format=750w'
          }
          style={{ width: 18, height: 18 }}
          alt="close"
        />
      </div>

      <div className="popup-left">
        <img
          src={
            'https://images.squarespace-cdn.com/content/v1/5e8cc39390c57e55e266b95b/c57261e0-00c3-4b88-9b84-79b3d452f40c/myuti-bubble.png?format=750w'
          }
          style={{ width: 92, height: 92 }}
          alt="bubble"
        />
        <div className="poweredByEmaPopUp">Powered by Ema v2.0.0</div>
      </div>

      <div className="popup-right">
        <div className="popup-title">
          <div style={{ fontSize: 40, marginTop: 10, marginRight: 7 }}>
            Meet
          </div>
          <img
            src={
              'https://images.squarespace-cdn.com/content/v1/5e8cc39390c57e55e266b95b/8aae873b-a1c5-4a85-8f2b-9c3574a5a121/myuti-mya.png?format=1000w'
            }
            style={{ height: 56 }}
            alt="mya"
          />
        </div>
        <div className="popup-text">
          Your AI guide to UTIs and women’s health.
        </div>

        <div
          className="popup-button"
          onClick={() => window.parent.postMessage('openChat', '*')}
        >
          <div style={{ marginLeft: 20, marginRight: 10 }}>
            Ask me a question
          </div>
          <img
            style={{ width: 20, height: 20, marginRight: 20 }}
            src={
              'https://images.squarespace-cdn.com/content/v1/5e8cc39390c57e55e266b95b/e14fe780-2126-479e-afc2-b3f97767bb19/myuti-send.png?format=750w'
            }
            alt="Send"
          />
        </div>
      </div>
    </div>
  );
};

export default MyaPopUp;
